import React from 'react';
type BadgeVariant = 'gold' | 'slate' | 'charcoal' | 'outline' | 'compliance';
interface BadgeProps {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
  icon?: React.ReactNode;
}
const variantClasses: Record<BadgeVariant, string> = {
  gold: 'bg-[#B08D57]/15 text-[#6B4F28] border border-[#B08D57]/30',
  slate: 'bg-[#2F3A45]/10 text-[#2F3A45] border border-[#2F3A45]/20',
  charcoal: 'bg-[#1C1F23] text-[#F7F7F5] border border-transparent',
  outline: 'bg-transparent text-[#2F3A45] border border-[#D8D8D4]',
  compliance: 'bg-emerald-50 text-emerald-800 border border-emerald-200'
};
export function Badge({
  children,
  variant = 'slate',
  className = '',
  icon
}: BadgeProps) {
  return <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-semibold font-body tracking-wide ${variantClasses[variant]} ${className}`} data-id="element-591">
      {icon && <span aria-hidden="true" data-id="element-592">{icon}</span>}
      {children}
    </span>;
}